import React from 'react';
import Icon from '../../../components/AppIcon';

const SessionStats = ({ 
  accuracy = 0, 
  timeElapsed = 0, 
  streak = 0, 
  points = 0,
  versesCompleted = 0,
  totalVerses = 0,
  className = '' 
}) => {
  const formatTime = (seconds) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${secs?.toString()?.padStart(2, '0')}`;
  };

  const stats = [
    {
      label: 'Accuracy',
      value: `${accuracy}%`,
      icon: 'Target',
      color: accuracy >= 80 ? 'var(--color-success)' : accuracy >= 60 ? 'var(--color-warning)' : 'var(--color-error)',
      bgColor: accuracy >= 80 ? 'bg-success/10' : accuracy >= 60 ? 'bg-warning/10' : 'bg-error/10'
    },
    {
      label: 'Time',
      value: formatTime(timeElapsed),
      icon: 'Clock',
      color: 'var(--color-primary)',
      bgColor: 'bg-primary/10'
    },
    {
      label: 'Streak',
      value: streak,
      icon: 'Flame',
      color: 'var(--color-accent)',
      bgColor: 'bg-accent/10'
    },
    {
      label: 'Points',
      value: points?.toLocaleString(),
      icon: 'Star',
      color: 'var(--color-warning)',
      bgColor: 'bg-warning/10'
    }
  ];

  return (
    <div className={`bg-card rounded-lg p-6 shadow-warm ${className}`}>
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-heading font-semibold text-card-foreground">
          Session Progress
        </h3>
        <div className="text-sm text-muted-foreground">
          {versesCompleted}/{totalVerses} verses
        </div>
      </div>
      {/* Progress Bar */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-2">
          <span className="text-sm font-medium text-foreground">Overall Progress</span>
          <span className="text-sm text-muted-foreground">
            {totalVerses > 0 ? Math.round((versesCompleted / totalVerses) * 100) : 0}%
          </span>
        </div>
        <div className="w-full bg-muted rounded-full h-2">
          <div
            className="bg-primary h-2 rounded-full transition-all duration-300"
            style={{ 
              width: `${totalVerses > 0 ? (versesCompleted / totalVerses) * 100 : 0}%` 
            }}
          />
        </div>
      </div>
      {/* Stats Grid */}
      <div className="grid grid-cols-2 gap-4">
        {stats?.map((stat) => (
          <div
            key={stat?.label}
            className={`${stat?.bgColor} rounded-lg p-4 text-center`}
          >
            <div className="flex items-center justify-center mb-2">
              <Icon name={stat?.icon} size={20} color={stat?.color} />
            </div>
            <div className="space-y-1">
              <p className="text-xl font-mono font-semibold" style={{ color: stat?.color }}>
                {stat?.value}
              </p>
              <p className="text-xs font-caption text-muted-foreground">
                {stat?.label}
              </p>
            </div>
          </div>
        ))}
      </div>
      {/* Achievement Notifications */}
      {accuracy >= 90 && (
        <div className="mt-4 bg-success/10 border border-success/20 rounded-lg p-3">
          <div className="flex items-center space-x-2">
            <Icon name="Trophy" size={16} color="var(--color-success)" />
            <span className="text-sm font-medium text-success">
              Excellent! 90%+ accuracy achieved!
            </span>
          </div>
        </div>
      )}
      {streak >= 5 && (
        <div className="mt-2 bg-accent/10 border border-accent/20 rounded-lg p-3">
          <div className="flex items-center space-x-2">
            <Icon name="Zap" size={16} color="var(--color-accent)" />
            <span className="text-sm font-medium text-accent">
              On fire! {streak} verse streak!
            </span>
          </div>
        </div>
      )}
    </div>
  );
};

export default SessionStats;